
/*eslint-disable*/
import { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import SidebarItem from "./SideBarItem";
import SidebarDropdown from "./SideBarDropdown";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  //  useEffect(() => {
  //     const bodyClassList = document.body.classList;
  //     if (isSidebarOpen) {
  //       bodyClassList.add("sidebar-open");
  //       bodyClassList.remove("g-sidenav-pinned");
  //     } else {
  //       bodyClassList.remove("sidebar-open");
  //       bodyClassList.add("g-sidenav-hidden");
  //     }
  //   }, [isSidebarOpen]);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  const toggleSidebar = () => {
    // setIsSidebarOpen(!isSidebarOpen);
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.submenu) {
        return (
          <SidebarDropdown key={key} title={prop.name} icon={prop.icon} submenu={prop.submenu} path={prop.path}>
            {prop.submenu.map((subProp, subKey) => (
              <SidebarItem key={subKey} to={subProp.layout + subProp.path} tag={NavLinkRRD}>
                {subProp.name}
              </SidebarItem>
            ))}
          </SidebarDropdown>
        );
      }

      return (
        <SidebarItem key={key} to={prop.layout + prop.path} tag={NavLinkRRD}>
          <i className={prop.icon} />
          {prop.name}
        </SidebarItem>
      );
    });
  };


  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
<>
    { isMobile? ( 
      <Navbar expand = "md" id = "sidenav-main" className = {` navbar-expand-xs p-3 fixed-start sidebar`} >

    <Container fluid >

      <div className="container-fluid py-1 px-3">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-md-none mr-3">
              <a href="javascript:;"  onClick={toggleCollapse} className="nav-link p-0">
                <div className="sidenav-toggler-inner">
                  <i className="sidenav-toggler-line bg-white"></i>
                  <i className="sidenav-toggler-line bg-white"></i>
                  <i className="sidenav-toggler-line bg-white"></i>
                </div>
              </a>
            </div>
            <h6 className="font-weight-bolder text-white mb-0">Dashboard</h6>
          </div>
  
          <div className="d-flex align-items-center">
            <a href="javascript:;" className="nav-link text-white p-0">
              <i className="fa fa-cog fixed-plugin-button-nav cursor-pointer"></i>
            </a>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <a href="javascript:;" className="nav-link text-white p-0" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fa fa-bell cursor-pointer"></i>
                  </a>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <ul className="dropdown-menu  dropdown-menu-end  px-2 py-3 me-sm-n4" aria-labelledby="dropdownMenuButton">
                  <li className="mb-2">
                    <a className="dropdown-item border-radius-md" href="javascript:;">
                      <div className="d-flex py-1">
                        <div className="my-auto">
                          <img src="../assets/img/team-2.jpg" className="avatar avatar-sm  me-3 " />
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <h6 className="text-sm font-weight-normal mb-1">
                            <span className="font-weight-bold">New message</span> from Laur
                          </h6>
                          <p className="text-xs text-secondary mb-0">
                            <i className="fa fa-clock me-1"></i>
                            13 minutes ago
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="mb-2">
                    <a className="dropdown-item border-radius-md" href="javascript:;">
                      <div className="d-flex py-1">
                        <div className="my-auto">
                          <img src="../assets/img/small-logos/logo-spotify.svg" className="avatar avatar-sm bg-gradient-dark  me-3 " />
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <h6 className="text-sm font-weight-normal mb-1">
                            <span className="font-weight-bold">New album</span> by Travis Scott
                          </h6>
                          <p className="text-xs text-secondary mb-0">
                            <i className="fa fa-clock me-1"></i>
                            1 day
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item border-radius-md" href="javascript:;">
                      <div className="d-flex py-1">
                        <div className="avatar avatar-sm bg-gradient-secondary  me-3  my-auto">
  
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <h6 className="text-sm font-weight-normal mb-1">
                            Payment successfully completed
                          </h6>
                          <p className="text-xs text-secondary mb-0">
                            <i className="fa fa-clock me-1"></i>
                            2 days
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src="https://ca.slack-edge.com/T025RRTC2SG-U033PPZ7Y5C-3ac313bb577b-512"
                    />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold text-white">
                      Admin
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right style={{ transform: 'translate3d(-19px, -15px, 0px)' }}>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={() => logout()}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
     
      </div>


    <Collapse navbar isOpen={collapseOpen}>
        {/* Collapse header */}
        <div className="navbar-collapse-header d-md-none">
          <Row>
            {logo ? (
              <Col className="collapse-brand" xs="6">
                {logo.innerLink ? (
                  <Link to={logo.innerLink}>
                    <img alt={logo.imgAlt} src={logo.imgSrc} />
                  </Link>
                ) : (
                  <a href={logo.outterLink}>
                    <img alt={logo.imgAlt} src={logo.imgSrc} />
                  </a>
                )}
              </Col>
            ) : null}
            <Col className="collapse-close" xs="6">
              <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
                <span />
                <span />
              </button>
            </Col>
          </Row>
        </div>

        {/* Form */}

        <Form className="mt-4 mb-3 d-md-none">
          <InputGroup className="input-group-rounded input-group-merge">
            <Input
              aria-label="Search"
              className="form-control-rounded form-control-prepended"
              placeholder="Search"
              type="search"
            />
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <span className="fa fa-search" />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Form>

        {/* Navigation */}
        <Nav navbar>
          {createLinks(routes)}
          {/* Create your navigation links */}
          {/* You can use the 'createLinks' function here to generate navigation links */}
        </Nav>
      </Collapse>

  
      </Container>
  </Navbar >) :
(<Navbar expand="md" id="sidenav-main" className={`navbar-vertical navbar-expand-md fixed-left navbar-light bg-white p-3 fixed-start sidebar`}>
  <Container fluid>

    {/* Brand */}
    {logo ? (
      <NavbarBrand className="pt-0">
        <div className="sidenav-header">
          <i className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav" />
          <a className="navbar-brand m-0" href="/admin/index">
            <img alt={logo.imgAlt} className="navbar-brand-img h-100" src={logo.imgSrc} style={{ width: "19%" }} />
            <span className="ms-1 font-weight-bold">
              <img alt={logo.imgAlt} className="navbar-brand-img h-100" src={logo.icon} style={{ width: "63%" }} />
            </span>
          </a>
        </div>
      </NavbarBrand>
    ) : null}

    <hr className="horizontal dark mt-0" />

    {/* User */}
    <Nav className="align-items-center d-md-none">
      <UncontrolledDropdown nav>
        <DropdownToggle nav className="nav-link-icon">
          <i className="ni ni-bell-55" />
        </DropdownToggle>
        <DropdownMenu
          aria-labelledby="navbar-default_dropdown_1"
          className="dropdown-menu-arrow"
          right
        >
          <DropdownItem>Action</DropdownItem>
          <DropdownItem>Another action</DropdownItem>
          <DropdownItem divider />
          <DropdownItem>Something else here</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <UncontrolledDropdown nav>
        <DropdownToggle nav>
          <Media className="align-items-center">
            <span className="avatar avatar-sm rounded-circle">
              <img
                alt="..."
                src={require("../../assets/img/theme/team-1-800x800.jpg")}
              />
            </span>
          </Media>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-arrow" right>
          <DropdownItem className="noti-title" header tag="div">
            <h6 className="text-overflow m-0">Welcome!</h6>
          </DropdownItem>
          <DropdownItem to="/admin/user-profile" tag={Link}>
            <i className="ni ni-single-02" />
            <span>My profile</span>
          </DropdownItem>
          <DropdownItem to="/admin/user-profile" tag={Link}>
            <i className="ni ni-settings-gear-65" />
            <span>Settings</span>
          </DropdownItem>
          <DropdownItem to="/admin/user-profile" tag={Link}>
            <i className="ni ni-calendar-grid-58" />
            <span>Activity</span>
          </DropdownItem>
          <DropdownItem to="/admin/user-profile" tag={Link}>
            <i className="ni ni-support-16" />
            <span>Support</span>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
            <i className="ni ni-user-run" />
            <span>Logout</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </Nav>

    {/* Collapse */}
    <Collapse navbar isOpen={collapseOpen}>
      {/* Collapse header */}
      <div className="navbar-collapse-header d-md-none">
        <Row>
          {logo ? (
            <Col className="collapse-brand" xs="6">
              {logo.innerLink ? (
                <Link to={logo.innerLink}>
                  <img alt={logo.imgAlt} src={logo.imgSrc} />
                </Link>
              ) : (
                <a href={logo.outterLink}>
                  <img alt={logo.imgAlt} src={logo.imgSrc} />
                </a>
              )}
            </Col>
          ) : null}
          <Col className="collapse-close" xs="6">
            <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
              <span />
              <span />
            </button>
          </Col>
        </Row>
      </div>

      {/* Form */}

      <Form className="mt-4 mb-3 d-md-none">
        <InputGroup className="input-group-rounded input-group-merge">
          <Input
            aria-label="Search"
            className="form-control-rounded form-control-prepended"
            placeholder="Search"
            type="search"
          />
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <span className="fa fa-search" />
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </Form>

      {/* Navigation */}
      <Nav navbar>
        {createLinks(routes)}
        {/* Create your navigation links */}
        {/* You can use the 'createLinks' function here to generate navigation links */}
      </Nav>
    </Collapse>
  </Container>
</Navbar>)
  }
 

 </>


  
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // ... existing prop types ...
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      layout: PropTypes.string,
      path: PropTypes.string.isRequired,
      icon: PropTypes.string,
      submenu: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          layout: PropTypes.string,
          path: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};

export default Sidebar;
